import { Fragment } from 'react'
import { GetStaticProps, GetStaticPropsContext, NextPage } from 'next'
import { useTranslation } from 'next-i18next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'

import TutorOnDemandBiology from '~/tutor-on-demand/pages/TutorOnDemandBiology.page'
import { COMMON_TRANSLATION_MODULE_NAMES, DEFAULT_LAYOUT_TRANSLATION_MODULE_NAMES } from '~/shared/layouts/constants'
import { DefaultLayout } from '~/shared/layouts/DefaultLayout'
import SubjectMetatags, { SubjectType } from '~/components/Metadata/SubjectMetatags'

const TutorOnDemandBiologyPage: NextPage = () => {
  const { t } = useTranslation('tutorOnDemandBiology')
  const title = t('title')

  return (
    <Fragment>
      <SubjectMetatags metaDescription={t('metaDescription')} title={title} type={SubjectType.BIOLOGY} />

      <DefaultLayout zeroPadding>
        <TutorOnDemandBiology type={SubjectType.BIOLOGY} />
      </DefaultLayout>
    </Fragment>
  )
}

export const getStaticProps: GetStaticProps = async ({ locale }: GetStaticPropsContext) => ({
  props: {
    ...(await serverSideTranslations(locale as string, [
      ...DEFAULT_LAYOUT_TRANSLATION_MODULE_NAMES,
      ...COMMON_TRANSLATION_MODULE_NAMES,
      'tutorOnDemand',
      'tutorOnDemandBiology',
    ])),
  },
})

export default TutorOnDemandBiologyPage
